import { api } from '../../api/client';

/** The build the site is handing out, as `latest.json` describes it. */
export interface PublishedRelease {
  version: string;
  version_code: number;
  size: number;
  sha256: string;
  released: string;
}

export const publishedRelease = () => api.get<PublishedRelease | null>('/app/release');

/**
 * Put a build on the site.
 *
 * Both files go together and the server refuses a pair that disagrees — see
 * `release_service`. Sent as one multipart request rather than two calls, so
 * there is no moment at which the site carries one without the other.
 */
export function publishRelease(apk: File, manifest: File) {
  const body = new FormData();
  body.append('apk', apk);
  body.append('manifest', manifest);
  return api.postForm<PublishedRelease>('/app/release', body);
}
